module.exports = __webpack_public_path__ + "static/img/6810_phase_function_Paper_Points.0e8e918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6810_phase_function_Paper_Points.png
// module id = 6q19
// module chunks = 0